import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import React__default from 'react';
import styles from './Radio.module.css.js';

const Radio = React__default.forwardRef((props, ref) => {
    return (jsxRuntimeExports.jsxs("div", { className: styles.root, children: [jsxRuntimeExports.jsx("input", { type: "radio", className: styles.input, ref: ref, ...props }), jsxRuntimeExports.jsx("span", { className: styles.fakeRadio })] }));
});
Radio.displayName = 'Radio';

export { Radio };
//# sourceMappingURL=Radio.js.map
